import * as u from 'JS/utils'

u.domReady(function() {
  const media = document.querySelector('.js-accordion-images')
  const images = document.querySelectorAll('.js-accordion-image')
  const inputs = document.querySelectorAll('.js-accordion-input')

  if (media !== null) {
    Array.from(inputs).forEach(function(input) {
      input.addEventListener('change', function(e) {
        const id = e.target.id
        const checked = e.target.checked
        const activeImage = media.querySelector('.js-accordion-image[data-image-for="' + id + '"]')

        if (checked) {
          clearAllActive(images)
          activeImage.classList.add('active')
        }
      })
    });
  }
})

const clearAllActive = function(nodes, classNameToRemove) {
  const klass = classNameToRemove || 'active'
  Array.from(nodes).forEach( function(item) {
    item.classList.remove(klass)
  })
}

u.domReady(function() {
  const el = document.getElementById('cookies-bar');
  if (el) {
    const close = el.querySelector('button');

    let accepted = localStorage.getItem('farrpoint_cookie_accepted') || false

    if (!accepted) {
      el.classList.remove('closed')
    }

    close.addEventListener('click', function(e) {
      el.classList.add('closed')
      localStorage.setItem('farrpoint_cookie_accepted', true)
    })
  }
})

u.domReady(function() {
  const body = document.getElementsByTagName('body')[0]
  const nav = document.getElementsByClassName('header-navigation')[0]
  const input = document.getElementById('navigation_main')
  const dropdownButtons = document.getElementsByClassName('header-link--has-children')
  const dropdowns = document.getElementsByClassName('header-navigation_item')

  document.addEventListener('click', function() {
    closeAllDropdowns(dropdowns)
  })

  if(nav != undefined && input != undefined) {

    input.addEventListener('change', function(e) {
      e.stopImmediatePropagation();
      if(input.checked && !nav.classList.contains('open')) {
        nav.classList.add('open')
        body.classList.add('no-scroll')
      } else {
        nav.classList.remove('open')
        body.classList.remove('no-scroll')
      }
    })

    Array.from(dropdownButtons).forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (button.parentElement.classList.contains('open')) {
          e.target.blur()
          button.parentElement.classList.remove('open')
        } else {
          closeAllDropdowns(dropdowns)
          button.parentElement.classList.toggle('open')
        }

        //  This has to go as it causes some troubles on webkit
        // if (button.parentElement.classList.contains('open')) {
        //   u.onClickOutside(button, () => closeAllDropdowns(dropdowns))
        // }
      })
    })
  }

  const clientCarouselEl = document.querySelector('.clients-carousel')

  if (clientCarouselEl) {
    const clientBreakpoints = {
      768: { slidesPerView: 6 },
      1024: { slidesPerView: 8 },
      1400: { slidesPerView: 12 },
    }

    const getClientSlidesPerView = function(width) {
      const breakpoint = Object.keys(clientBreakpoints)
        .map(Number)
        .sort(function(a, b) { return b - a })
        .find(function(bp) { return width >= bp })

      return breakpoint ? clientBreakpoints[breakpoint].slidesPerView : 4
    }

    let clientSwiper = null
    let clientCarouselMode = null

    const getClientCarouselMode = function(slideCount, width) {
      const maxSlidesPerView = getClientSlidesPerView(width)

      if (slideCount <= maxSlidesPerView) {
        return 'static'
      }

      if (slideCount < maxSlidesPerView * 2) {
        return 'scroll'
      }

      return 'loop'
    }

    const resetStaticWrapper = function(swiper) {
      if (clientCarouselMode !== 'static') return
      swiper.wrapperEl.style.transform = 'none'
    }

    const initClientSwiper = function() {
      const slideCount = clientCarouselEl.querySelectorAll('.swiper-slide').length
      const mode = getClientCarouselMode(slideCount, window.innerWidth)

      if (clientSwiper) {
        clientSwiper.destroy(true, true)
        clientSwiper = null
      }

      clientCarouselMode = mode
      clientCarouselEl.classList.toggle('clients-carousel--static', mode === 'static')

      const swiperOptions = {
        direction: 'horizontal',
        loop: mode === 'loop',
        centeredSlides: false,
        allowTouchMove: mode !== 'static',
        watchOverflow: true,
        slidesPerView: 4,
        breakpoints: clientBreakpoints,
        on: {
          init: resetStaticWrapper,
          resize: resetStaticWrapper,
          breakpoint: resetStaticWrapper,
          update: resetStaticWrapper,
        },
      }

      clientSwiper = new Swiper(clientCarouselEl, swiperOptions)
    }

    initClientSwiper()

    let clientCarouselResizeTimer
    window.addEventListener('resize', function() {
      clearTimeout(clientCarouselResizeTimer)
      clientCarouselResizeTimer = setTimeout(function() {
        const slideCount = clientCarouselEl.querySelectorAll('.swiper-slide').length
        const mode = getClientCarouselMode(slideCount, window.innerWidth)

        if (mode !== clientCarouselMode) {
          initClientSwiper()
        } else if (mode === 'static' && clientSwiper) {
          clientSwiper.update()
          resetStaticWrapper(clientSwiper)
        }
      }, 150)
    })
  }

  const testimonialSwiper = new Swiper('.testimonials-swiper', {
    // Optional parameters
    direction: 'horizontal',
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: '.testimonials-swiper-next',
      prevEl: '.testimonials-swiper-prev',
    },
  });

})

const closeAllDropdowns = function(elements) {
  if (window.innerWidth >= 950) {
    Array.from(elements).forEach(function(el) {
      el.classList.contains('open') ? el.classList.remove('open') : null
    })
  }
}


// Scroll detection methods
u.domReady(function() {
  // Method 1: Simple scroll detection
  let isScrolled = false;
  
  window.addEventListener('scroll', function() {
    if (window.scrollY > 0 && !isScrolled) {
      isScrolled = true;
      // Add your scroll detection logic here
      document.body.classList.add('has-scrolled');
    } else if (window.scrollY === 0 && isScrolled) {
      isScrolled = false;
      document.body.classList.remove('has-scrolled');
    }
  });

  // Method 2: Detect scroll direction
  let lastScrollTop = 0;
  
  window.addEventListener('scroll', function() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > lastScrollTop) {
      // Scrolling down
      document.body.classList.add('scrolling-down');
      document.body.classList.remove('scrolling-up');
    } else {
      // Scrolling up
      document.body.classList.add('scrolling-up');
      document.body.classList.remove('scrolling-down');
    }
    
    lastScrollTop = scrollTop;
  });

  // Method 3: Detect scroll amount
  window.addEventListener('scroll', function() {
    const scrollY = window.scrollY;
    
    if (scrollY > 100) {
      document.body.classList.add('scrolled-past-100');
    } else {
      document.body.classList.remove('scrolled-past-100');
    }
    
    if (scrollY > 500) {
      document.body.classList.add('scrolled-past-500');
    } else {
      document.body.classList.remove('scrolled-past-500');
    }
  });

  // Method 4: Throttled scroll detection (better performance)
  let ticking = false;
  
  function updateScrollClasses() {
    const scrollY = window.scrollY;
    
    // Add classes based on scroll position
    if (scrollY > 0) {
      document.body.classList.add('page-scrolled');
    } else {
      document.body.classList.remove('page-scrolled');
    }
    
    ticking = false;
  }
  
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(updateScrollClasses);
      ticking = true;
    }
  });
});
